import {Injectable} from "@angular/core";
import "km-nets-smartpos";
import {Plugins} from "@capacitor/core";
import {Observable, Subscriber} from "rxjs";
import {PaymentRow} from "../types/paymentrow";
import {ConfigurationService} from "./configuration";
import {CardPayment} from "../types/cardPayment";
import {Receipt} from "../types/receipt";
import {Logger, LoggingService} from "ionic-logging-service";
import {PaymentLine} from "../types/paymentLine";
import {UtilsService} from "./utils";
import { Platform } from "@ionic/angular";
// eslint-disable-next-line @typescript-eslint/naming-convention
const {NetsSmartPos} = Plugins;

@Injectable()
export class CardPaymentServiceNets implements CardPayment {

  private logger: Logger;

  constructor(private conf: ConfigurationService, private loggingService: LoggingService, private utils: UtilsService,
    private platform: Platform) {
    this.logger = loggingService.getLogger("BestoGo.CardPaymentServiceNets");
  }

  public pay(receipt: Receipt, paymentLine): Observable<PaymentRow> {
    const receiptRows = receipt.rows;
    const pr = new Observable((observer: Subscriber<PaymentRow>) => {
      if (this.conf.getPlatform() === "ios") {
        this.logger.error("pay", "iOS pay not supported: ", receiptRows, paymentLine);
        observer.error("iOS not supported yet");
        return;
      }

      NetsSmartPos.pay(paymentLine).then((success) => {
        this.logger.info("pay", "Payment finished", success);
        if (success.errorMessage) {
          observer.error(success.errorMessage);
        } else {
          observer.next({
            payment: "CARD",
            sum: parseFloat(success.sum) / 100,
            realSum: parseFloat(success.sum) / 100,
            cardTerminalTransactionId: success.cardTerminalTransactionId,
            authorization: success.authorization,
            cardTerminalUsageMode: success.cardTerminalUsageMode,
            rawPtData: success.rawPtData
          });
        }
      }).catch((error) => {
        observer.error(error);
      });
      return {
        unsubscribe: () => {
        }
      };
    });
    return pr;
  }

  public refund(receipt, paymentLine): Observable<PaymentRow> {
    const receiptRows = receipt.rows;
    const pr = new Observable((observer: Subscriber<PaymentRow>) => {
      if (this.conf.getPlatform() === "ios") {
        this.logger.error("pay", "iOS refund not supported: ", receiptRows, paymentLine);
        observer.error("iOS not supported yet");
        return;
      }
      const refundLine: PaymentLine = {
        amount: (paymentLine.sum * 100) as unknown as bigint,
        currency: this.conf.getCurrency()
      };
      NetsSmartPos.refund(refundLine).then((success) => {
        this.logger.info("refund", "Refund finished", success);
        if (success.errorMessage) {
          observer.error(success.errorMessage);
        } else {
          observer.next({
            payment: "CARD",
            sum: -parseFloat(success.sum) / 100,
            realSum: -parseFloat(success.sum) / 100,
            cardTerminalTransactionId: success.cardTerminalTransactionId,
            authorization: success.authorization,
            cardTerminalUsageMode: success.cardTerminalUsageMode,
            rawPtData: success.rawPtData
          });
        }
      }).catch((error) => {
        observer.error(error);
      });
      return {
        unsubscribe: () => {
        }
      };
    });
    return pr;
  }

  public abortPayment(receipt: Receipt): Observable<Receipt> {
    const pr = new Observable((observer: Subscriber<Receipt>) => {
      this.logger.error("abortPayment", "Not supported");
      observer.error("Not supported");
      return {
        unsubscribe: () => {
        }
      };
    });
    return pr;
  }

  getId(): string {
    return "Nets SmartPos";
  }

  init(): void {
    NetsSmartPos.immersiveMode().then((success) => {
      this.logger.info("init", "Nets set immersive mode", success);
    });
    this.logger.debug("init", "Nets smartpos initiated");
  }

  getStatus(): Observable<string> {
    const pr = new Observable((observer: Subscriber<string>) => {
      if (this.conf.getPlatform() === "ios") {
        observer.next("NOT CONFIGURED");
      } else {
        observer.next("READY");
      }
      return {
        unsubscribe: () => {
        }
      };
    });
    return pr;
    ;
  }

  getPosMessage(): Observable<string> {
    const pr = new Observable((observer: Subscriber<string>) => ({
      unsubscribe: () => {
      }
    }));
    return pr;
  }

  endOfDayReconciliation(day: Date): Observable<any> {
    const pr = new Observable((observer: Subscriber<any>) => {
      if (this.conf.getPlatform() === "ios") {
        this.logger.error("pay", "iOS reconciliation not supported: ");
        observer.error("iOS not supported yet");
        return;
      }
      if (this.utils.checkIfToday(day)) {
        NetsSmartPos.endOfDayReconciliation().then((success) => {
          this.logger.info("reconciliate", "Reconciliation finished", success);
          observer.next(true);
        }).catch((error) => {
          observer.error(error);
        });
        return {
          unsubscribe: () => {
          }
        };
      } else {
        observer.next(true);
        this.logger.info("reconciliate", "No need to reconciliate older " +
          "days in Nets, silently ignoring");
      }
    });
    return pr;

  }

}
